import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to start a sidehustle",
  "description": "",
  "published": "2017-07-20T00:00:00.000Z",
  "redirect_from": ["/blog/start-sidehustle/swizec/7716"],
  "categories": "Business, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/07/IMG_7860-1024x575.jpg",
        "alt": null
      }}></img></p>
    <p>{`Make a thing. Add Buy button. Tell people.`}</p>
    <p>{`If you `}<a parentName="p" {...{
        "href": "https://blog.ycombinator.com/why-should-i-start-a-startup/"
      }}>{`have the entrepreneurial itch`}</a>{` but don't have the financial security to back up the risk, becoming a bootstrapped micropreneur is a great first choice.`}</p>
    <p>{`Start your business on the side, and once its revenue is high enough to live on, make the jump. It's slower than a funded startup, but it’s a lot less risky.`}</p>
    <p>{`Sure, it comes with a social opportunity cost (long nights and weekends), but so does a startup. People say startups are `}<a parentName="p" {...{
        "href": "http://www.paulgraham.com/wealth.html"
      }}>{`a way to compress your whole working life into a few years`}</a>{`.`}</p>
    <p>{`If your sidehustle does well, you can later leverage it to fund your big startup idea. Or, hell, live a good life on a lifestyle business making a few hundred thousand per year.`}</p>
    <p>{`$150k/year revenue won't get you any headlines, but it's plenty to live on and run a solo business.`}</p>
    <p>{`Get to $500k/year, and you have a higher expected ROI over N years than any startup founder.`}</p>
    <p>{`Think about it. A digital business can have almost infinite margins. Once you build the thing, your only expenses are marketing, support, a few SaaS services, and a helping hand or two.`}</p>
    <p>{`What if you made $500k/year in revenue, and $400k of it was pure margin? $400k of cold hard cash, just for you, every year. How happy would you be?`}</p>
    <p>{`What about if you made $1,000,000,000/year in revenue, had 10,000 employees, 20 board members, a $200k salary, and $500,000,000 of imaginary money you can't turn into cash (stock). Would `}<em parentName="p">{`that`}</em>{` make you happy?`}</p>
    <p>{`My sidehustle is a combination of books and teaching. I'm experimenting with coaching, and a company is sponsoring my React Native writing on a `}<a parentName="p" {...{
        "href": "https://school.shoutem.com/"
      }}>{`cobranded blog/YT channel`}</a>{`.`}</p>
    <p>{`I publish `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/4093-june-sidehustle-report/swizec/7681"
      }}>{`monthly breakdowns`}</a>{`, and that lists all revenue streams and expenses.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Midpoint of year, sidehustle revenue exactly as much as all of last year. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/ontrack?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#ontrack`}</a>{` 💪🏼`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/886790354493517824"
      }}>{`July 17, 2017`}</a></blockquote>
    <p>{`Expenses come down to about $2000/month, and I'm well on track to make around $50k this year. That's with about `}<em parentName="p">{`60 hours per month`}</em>{` of active work.`}</p>
    <p>{`If I didn't insist on living in SF, I could have a very cushy life back in Slovenia. $24k expenses, $24k personal salary. Average salary in Ljubljana – my hometown – is $25k. For people who work 160 hours per month 😉`}</p>
    <hr></hr>
    <p>{`I never had an official mentor, but plenty of people helped and nudged me in the right direction and answered my questions. You can find most of them on the internets.`}</p>
    <p>{`It all boils down to this: Make things. Add "Pay For Thing" button. Tell people.`}</p>
    <p>{`I started with following `}<a parentName="p" {...{
        "href": "https://www.iwillteachyoutoberich.com/"
      }}>{`Ramit Sethi's`}</a>{` emails for a few years (he's great to drive home the point that yes you do deserve to get paid), then `}<a parentName="p" {...{
        "href": "https://doubleyourfreelancing.com/"
      }}>{`Brennan Dunn's`}</a>{` emails and content (he's great for "you totes can make shitloads"), then `}<a parentName="p" {...{
        "href": "http://nathanbarry.com/"
      }}>{`Nathan Barry's`}</a>{` book Authority which is great for "Here are concrete steps to start making bank", and I went to Dunn's `}<a parentName="p" {...{
        "href": "http://doubleyourfreelancing.com/conf/"
      }}>{`DYFConf`}</a>{` which is like a baby `}<a parentName="p" {...{
        "href": "http://www.microconf.com/"
      }}>{`MicroConf`}</a>{` (to which I want to go, but still haven't), oh and of course I listened to all mp3s of all past talks from MicroConf. `}<a parentName="p" {...{
        "href": "https://twitter.com/patio11"
      }}>{`Patio11's`}</a>{` writings helped a lot as well. I used `}<a parentName="p" {...{
        "href": "http://videofruit.com/blog/"
      }}>{`Bryan Harris`}</a>{` stuff for ideas on growing an audience, and `}<a parentName="p" {...{
        "href": "https://kaidavis.com/"
      }}>{`Kai Davis`}</a>{` is great for being a cheerleader and giving good ideas on positioning and writing.`}</p>
    <p>{`Somehow I got invited to the Slack group where many of these micropreneur/microconf celebrities hang out and that's been superb as well. Much inspiration, many great ideas.`}</p>
    <p>{`Oh and I used Ken Wallace's `}<a parentName="p" {...{
        "href": "https://mastermindjam.com/"
      }}>{`MastermindJam`}</a>{` to join a mastermind of likeminded peers. That helps with keeping you accountable and shipping stuff.`}</p>
    <p>{`I also used Amy Hoy's `}<a parentName="p" {...{
        "href": "https://30x500.com/academy/"
      }}>{`30x500`}</a>{`, but I bought that too late (or too early, hard to say) and it didn't help super much. I should revisit.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/levelsio"
      }}>{`Pieter Levels'`}</a>{` twitter stream is also a huge bundle of inspiration.`}</p>
    <p>{`But really Patio11's tweetstorm says it best:`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`You don't need a mentor to start a business. You don't need a mentor to learn a new programming language. You can just straight-up do these.`}</p>{`— Patrick McKenzie (@patio11) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/patio11/status/887793614780235777"
      }}>{`July 19, 2017`}</a></blockquote>
    <p>{`Make something. Charge for it. Congratz, you're a business.`}</p>
    <p><em parentName="p">{`This post first appeared as a `}<a parentName="em" {...{
          "href": "https://news.ycombinator.com/item?id=14807198"
        }}>{`thread on HackerNews`}</a></em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      